import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '../locales/en.json';
import es from '../locales/es.json';
import fr from '../locales/fr.json';

const savedLang = typeof window !== 'undefined' ? localStorage.getItem('i18nextLng') : null;
const browserLang = typeof window !== 'undefined' ? navigator.language?.split('-')[0] : null;

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    es: { translation: es },
    fr: { translation: fr },
  },
  lng: savedLang || browserLang || 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
  detection: {
    caches: ['localStorage'],
  },
});

export default i18n;
